import { Common } from "../actionTypes/common";

export const downloadPdf = (payload) => ({
  type: Common.DOWNLOAD_PDF,
  payload,
});
